import { absolutePath } from "./absolutePath";

export const pinnedChatRoom = {
  create: ({ uuid }: { uuid: string }) =>
    absolutePath(`chat_rooms/${uuid}/pinned_chat_rooms`),
  destroy: ({ uuid }: { uuid: string }) =>
    absolutePath(`chat_rooms/${uuid}/pinned_chat_rooms`),
};
